export default "__VITE_PUBLIC_ASSET__a59e93b8__"